import { motion } from "framer-motion";
import { CATEGORY_ORDER, CATEGORY_LABEL, CATEGORY_COLOR } from "@/data/quiz";

export default function ScoreBar({ scores }) {
  const max = 8;
  return (
    <div data-testid="score-chart">
      <p className="text-xs uppercase tracking-widest font-semibold text-[#5a686b] mb-5">
        Your choices across the eight questions
      </p>
      <div className="space-y-4">
        {CATEGORY_ORDER.map((cat, i) => {
          const value = scores[cat] || 0;
          const pct = (value / max) * 100;
          return (
            <div key={cat} data-testid={`score-row-${cat}`}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-sm font-medium text-[#1e292b]">{CATEGORY_LABEL[cat]}</span>
                <span className="text-sm font-semibold text-[#5a686b]" data-testid={`score-value-${cat}`}>
                  {value} / {max}
                </span>
              </div>
              <div className="h-3 w-full rounded-full bg-[#f2eee9] overflow-hidden">
                <motion.div
                  className="h-full rounded-full"
                  style={{ backgroundColor: CATEGORY_COLOR[cat] }}
                  initial={{ width: 0 }}
                  animate={{ width: `${pct}%` }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: "easeOut" }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
